import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var IntlContext = React.createContext(null);

var IntlProvider = function (_ref) {
  var locale = _ref.locale,
      messageFormatter = _ref.messageFormatter,
      currencyFormatter = _ref.currencyFormatter,
      getDisplayNamesObject = _ref.getDisplayNamesObject,
      phoneFormatter = _ref.phoneFormatter,
      addressFormatter = _ref.addressFormatter,
      exampleGenerator = _ref.exampleGenerator,
      dateTimeFormatter = _ref.dateTimeFormatter,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["locale", "messageFormatter", "currencyFormatter", "getDisplayNamesObject", "phoneFormatter", "addressFormatter", "exampleGenerator", "dateTimeFormatter", "children"]);

  return /*#__PURE__*/React.createElement(IntlContext.Provider, {
    value: _objectSpread({
      locale: locale,
      messageFormatter: messageFormatter,
      currencyFormatter: currencyFormatter,
      getDisplayNamesObject: getDisplayNamesObject,
      phoneFormatter: phoneFormatter,
      addressFormatter: addressFormatter,
      exampleGenerator: exampleGenerator,
      dateTimeFormatter: dateTimeFormatter
    }, rest)
  }, children);
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getFormattedMessage = function (intlContext, defaultMessage, id, variables) {
  if (!id) {
    return defaultMessage;
  }

  if (!(intlContext && intlContext.messageFormatter)) {
    return id;
  }

  return intlContext.messageFormatter({
    id: id
  }).format(variables);
};
var getCurrencyMaskOptions = function (intlContext, maskOptions, currencyType) {
  if (intlContext && intlContext.currencyFormatter) {
    var currencyFormat = intlContext.currencyFormatter({
      currency: currencyType
    });
    var currencyPartsArr = currencyFormat.formatToParts(1000);

    var _getIntlCurrencyPatte = getIntlCurrencyPattern(currencyPartsArr),
        intlMaskOptions = _getIntlCurrencyPatte.intlMaskOptions,
        intlCurrencyPrefix = _getIntlCurrencyPatte.intlCurrencyPrefix,
        intlCurrencySuffix = _getIntlCurrencyPatte.intlCurrencySuffix; //set mask-options padFractionalZeros to false and scale to 0 if currency does not support fractional values


    var currencyFormatOptions = currencyFormat.resolvedOptions();

    if (currencyFormatOptions.maximumFractionDigits === 0) {
      intlMaskOptions.padFractionalZeros = false;
      intlMaskOptions.scale = 0;
    }

    return {
      currencyMaskOptions: _objectSpread$1(_objectSpread$1({
        padFractionalZeros: true
      }, intlMaskOptions), maskOptions),
      intlCurrencyPrefix: intlCurrencyPrefix,
      intlCurrencySuffix: intlCurrencySuffix
    };
  }

  return {
    currencyMaskOptions: maskOptions
  };
};

function getIntlCurrencyPattern(currencyPartsArr) {
  var intlMaskOptions = {
    mask: Number
  };
  var intlCurrencyPrefix = '';
  var intlCurrencySuffix = '';
  currencyPartsArr.forEach(function (_ref, idx) {
    var type = _ref.type,
        value = _ref.value;

    switch (type) {
      case 'currency':
        if (idx === 0) {
          intlCurrencyPrefix = value;
        } else {
          intlCurrencySuffix = value;
        }

        break;

      case 'group':
        intlMaskOptions.thousandsSeparator = value;
        break;

      case 'fraction':
        intlMaskOptions.scale = value.length;
        break;

      case 'decimal':
        intlMaskOptions.radix = value;
        break;
    }
  });
  return {
    intlMaskOptions: intlMaskOptions,
    intlCurrencyPrefix: intlCurrencyPrefix,
    intlCurrencySuffix: intlCurrencySuffix
  };
}

export { IntlContext, IntlProvider, getCurrencyMaskOptions, getFormattedMessage };
